"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const labelButton_1 = __importDefault(require("../../components/labelButton/labelButton"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const pressableElement_1 = __importDefault(require("../../components/pressables/pressableElement"));
const screenConstants_1 = require("../../constants/screenConstants");
const useGetUpdates_1 = __importDefault(require("../../hooks/useGetUpdates"));
const store_1 = require("../../store");
const styles_1 = __importDefault(require("../../styles/styles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const loanActive_1 = __importDefault(require("./loanActive"));
const loanConstants_1 = require("./loanConstants");
const loanHistory_1 = __importDefault(require("./loanHistory"));
const loanStyles_1 = __importDefault(require("./loanStyles"));
const LoanBase = () => {
    (0, useGetUpdates_1.default)();
    const { activeLoan, ongoingLoanApplication, warnings, loanHistory, npsSurvey, userData } = (0, store_1.useAppSelector)((state) => ({
        loanHistory: state.home.loan_history,
        activeLoan: state.home.active_loan,
        ongoingLoanApplication: state.home.ongoing_application,
        warnings: state.home.warnings,
        npsSurvey: state.home.nps_survey,
        userData: state.home.user_data,
    }));
    const [showTab, setShowTab] = (0, react_1.useState)(loanConstants_1.ACTIVE_LOAN_TAB);
    let content;
    if (showTab === loanConstants_1.ACTIVE_LOAN_TAB) {
        content = (react_1.default.createElement(loanActive_1.default, { activeLoan: activeLoan, ongoingLoanApplication: ongoingLoanApplication, warnings: warnings, npsSurvey: npsSurvey, submittedRating: userData ? !!userData.user_submitted_rating : true }));
    }
    else {
        content = react_1.default.createElement(loanHistory_1.default, { loanHistory: loanHistory });
    }
    return (react_1.default.createElement(navContainer_1.default, { header: react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.mainContainerPadding, { height: 50 }] },
            react_1.default.createElement(pressableElement_1.default, { style: [
                    loanStyles_1.default.tab,
                    showTab === loanConstants_1.ACTIVE_LOAN_TAB ? loanStyles_1.default.tabActiveContentStyle : loanStyles_1.default.tabInactiveContentStyle,
                ], onPress: () => setShowTab(loanConstants_1.ACTIVE_LOAN_TAB), eventName: "loan_loanActive" },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(labelButton_1.default, { disabled: showTab === loanConstants_1.ACTIVE_LOAN_TAB, title: "ACTIVE", onPress: () => setShowTab(loanConstants_1.ACTIVE_LOAN_TAB), textColor: showTab === loanConstants_1.ACTIVE_LOAN_TAB ? theme_1.default.colors.COLOR_PRIMARY : theme_1.default.colors.COLOR_GRAY, eventName: "loan_loanActive" }))),
            react_1.default.createElement(pressableElement_1.default, { style: [
                    loanStyles_1.default.tab,
                    showTab === loanConstants_1.HISTORY_LOAN_TAB
                        ? loanStyles_1.default.tabActiveContentStyle
                        : loanStyles_1.default.tabInactiveContentStyle,
                ], onPress: () => setShowTab(loanConstants_1.HISTORY_LOAN_TAB), eventName: "loan_loanHistory" },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(labelButton_1.default, { disabled: showTab === loanConstants_1.HISTORY_LOAN_TAB, title: "HISTORY", onPress: () => setShowTab(loanConstants_1.HISTORY_LOAN_TAB), textColor: showTab === loanConstants_1.HISTORY_LOAN_TAB ? theme_1.default.colors.COLOR_PRIMARY : theme_1.default.colors.COLOR_GRAY, eventName: "loan_loanHistory" })))), footer: screenConstants_1.LOAN_HOME_SCREEN, isHomeContainer: true, isLoading: false }, content));
};
exports.default = LoanBase;
